import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, provide } from 'vue'
import { GeoImagesViewModel } from '../models/GeoImages.viewmodel'
import { GeoImagesViewModelKey } from '../keys/GeoImagesViewModel.key'

import Button from '../../../../components/Button/Button.vue'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'
import InputSearch from '../../../../components/InputSearch/InputSearch.vue'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox.vue'
import CrudTable from '../../../../components/CrudTable/CrudTable.vue'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu.vue'
import Pagination from '../../../../components/Pagination/Pagination.vue'
import CrudForm from '../../../../components/CrudForm/CrudForm.vue'
import GeoImageForm from '../components/GeoImageForm.vue'
import MapBandsForm from '../components/MapBandsForm.vue'
import StorageUsageBanner from '../components/StorageUsageBanner.vue'
import { Portal } from '@linusborg/vue-simple-portal'


export default /*#__PURE__*/_defineComponent({
  __name: 'GeoImages.page',
  setup(__props) {

const vm = new GeoImagesViewModel()
provide(GeoImagesViewModelKey, vm)

vm.fetchAll()
vm.fetchStorageUsage()

const ref__pagination = ref()

watch(vm.textFilter, () => {
	ref__pagination.value?.resetToFirstPage()
})

watch(
	vm.tableHeaders,
	(value) => {
		vm.headersSelecionados.value = value.filter((f) => f.isActive).map((m) => m.key)
	},
	{ deep: true },
)

watch(vm.intention, (value) => {
	const model = vm.modelList.value.find((m) => m.id === value.properties?.id)
	if (!model) return

	switch (value.intent) {
		case 'editar':
			vm.showEditModelForm(model)
			break
	}
})

return { __sfc: true,vm, ref__pagination, Button, ExclusionAlert, InputSearch, DropdownCheckbox, CrudTable, KebabMenu, Pagination, CrudForm, GeoImageForm, MapBandsForm, StorageUsageBanner, Portal }
}

})